<template>
    <div class="page">
        <div id="page">
            <div class="header row" style="border-bottom: black solid 2px">
                <div class="col-md-6">
                    <img src="/static/petrolimexaviation.jpg" class="img-responsive" alt="Image" style="width: 349px">
                </div>
                <div class="col-md-6">
                    <span class="pull-right text-uppercase" style="font-weight: bold;">
                        {{ $t('summary.minutes_of_meeting') }}
                    </span>
                </div>
            </div>
            <div class="body row mt-3">
                <div class="col-md-12 text-center">
                    <b class="text-uppercase">{{ $t('summary.minutes_of_meeting') }}
                        <br>{{ $t('summary.audit_result') }} {{ checklist.name }} - {{ checklist.organization ?
            checklist.organization.name : '' }}
                    </b><br>
                    <span>{{ $t('summary.date') }}: {{ date_now.date() }} {{ $t('summary.month') }} {{ date_now.month() + 1 }}
                        {{ $t('summary.year') }} {{ date_now.year() }} </span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 ng-binding">
                    <span style="padding: 0; font-weight: bold;">1. {{ $t('summary.auditors') }}: </span>
                </div>
                <div class="col-md-12" style="margin-left: 10px">
                    <span style="padding: 0; font-weight: bold;"> 1.1. {{ $t('summary.auditor_leader') }}: </span><br>
                    <span v-if="teams">
                    <span v-for="(user, key) in teams.Leader" :key="key">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ user.gender == "1" ? $t('summary.mr') :
            $t('summary.mrs') }}: {{ user.name }} - {{ user.pos_name }}<br>
                        </span>
                    </span>
                </div>
                <div class="col-md-12" style="margin-left: 10px">
                    <span style="padding: 0; font-weight: bold;"> 1.2. {{ $t('summary.auditor_auditor') }} : </span><br>
                    <span v-if="teams">
                        <span v-for="(user, key) in teams.Auditor" :key="key">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ user.gender == "1" ? $t('summary.mr') :
            $t('summary.mrs') }}: {{ user.name }} - {{ user.pos_name }}<br>
                        </span>
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ng-binding">
                    <span style="padding: 0;font-weight: bold;">
                        2. {{ $t('summary.auditees') }}: </span>
                    {{ checklist.organization ? checklist.organization.name : '' }} - {{ $t('summary.address') }} :
                    {{ checklist.organization ? checklist.organization.address : '' }}
                </div>
                <div class="col-md-12" v-if="teams">
                    <span v-for="(user, key) in teams.Auditee" :key="key">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ user.gender == "1"
            ? $t('summary.mr') : $t('summary.mrs') }}: {{ user.name }} - {{ user.pos_name }}<br></span>
                </div>
                <div class="col-md-12 "></div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <span style="padding: 0;font-weight: bold;">3. {{ $t('summary.audit_period') }}: </span>
                    <span style="padding: 0;" class="ng-binding">
                        {{ $t('summary.from') }}
                        {{ checklist.starting_date ? $moment(checklist.starting_date).format('DD-MM-YYYY') : '' }}
                        {{ $t('summary.to') }}
                        {{ date_now.date() }}-{{ date_now.month() + 1 }}-{{ date_now.year() }}
                    </span><br>
                </div>
                <div class="col-md-12 mt-3">
                    <span style="padding: 0;font-weight: bold;">4. {{ $t('summary.auditors_comment') }}: </span>
                </div>
                <div class="col-md-12 mt-1">
                    <span v-html="summary.conclusion"></span>
                </div>
                <div class="col-md-12 mt-3">
                    <span style="padding: 0;font-weight: bold;">5. {{ $t('summary.auditees_comment') }}: </span>
                </div>
                <div class="col-md-12 mt-1">
                    <span v-html="summary.self_assessment"></span>
                </div>
            </div>
            <div class="row">
                <span class="col-md-12">{{ $t('summary.p1') }}</span>
                <span class="col-md-12 p-0"> <b>{{ $t('summary.p2') }}</b></span>
            </div>
            <div class="row mt-3">
                <table class="col-md-12">
                    <thead style="background-color: #fff;">
                        <tr class="text-center">
                            <th style="width: 50%" class="text-uppercase">{{ $t('summary.auditor_representative')}}</th>
                            <th style="width: 50%" class="text-uppercase">{{$t('summary.auditee_representative')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="height: 12rem;">
                            <!-- <td class="button-profile "><span class="fontsummary">Tên trưởng đoàn</span></td> -->
                            <!-- <td class="button-profile "><span class="fontsummary">Tên đại diện tổ chức</span></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <button class="btn btn-primary pull-right" @click="print()">
                    <i class="fa fa-print"></i> {{$t('summary.print')}}
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import Helper from '@/Helper'
import { getAssessmentTeam } from '@/service/Apis'

export default {
  name: 'summary-detail',
  components: {},
  props: [],
  data () {
    return {
      loading: false,
      date_now: this.$moment(),
      users: null,
      checklist: {},
      checklistId: this.$route.params.checklist_id,
      summary: {},
      teams: []
    }
  },
  computed: {
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('Checklist/showChecklist', { checklist: { id: this.checklistId } }),
      this.$store.dispatch('Summary/showSummary', { checklist: { id: this.checklistId }, summary: { id: this.$route.params.summary_id } })
    ]).then(res => {
      this.checklist = res[0]
      this.summary = res[1]
      this.users = res[3]
    }).catch(errors => {
    })
    this.fetchTeam()
  },
  methods: {
    async fetchTeam () {
      try {
        const res = await getAssessmentTeam(this.checklistId)
        this.teams = Helper.sortTeam(res.data)
        console.log(this.teams)
      } catch (error) {
        console.log(error)
      }
    },
    print () {
      var innerContents = document.getElementById('page').innerHTML
      var popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no')
      popupWinindow.document.open()
      popupWinindow.document.write('<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"><link rel="stylesheet" href="/static/bootstrap.css"/><link rel="stylesheet" type="text/css" href="/static/print.css" /><link rel="stylesheet" type="text/css" href="/static/style.css" /></head><body onload="window.print()">' + innerContents + '</html>')
      popupWinindow.document.close()
    }
  }
}
</script>
<style lang="scss">
.page {
    min-height: 24.7cm;
    padding: 1cm;
    margin: 5px auto;
    border: 1px #D3D3D3 solid;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/view/summary-history/detail.vue